module.exports = __webpack_public_path__ + "img/GAME_OILPAINT.75a5e7c0.png";